import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { copyText, whatsappUrl } from "@/lib/share";

export const ShareActions = ({ text, testPrefix }) => {
  const copy = async () => {
    if (await copyText(text)) toast.success("Testo copiato, incollalo su WhatsApp");
    else toast.error("Copia non riuscita");
  };
  return (
    <div className="flex gap-2">
      <Button type="button" data-testid={`${testPrefix}-copy-btn`} variant="outline" onClick={copy} className="h-10 flex-1 gap-2 rounded-xl bg-white">
        <Copy className="h-4 w-4" /> Copia testo
      </Button>
      <Button asChild className="h-10 flex-1 gap-2 rounded-xl bg-emerald-600 hover:bg-emerald-700">
        <a data-testid={`${testPrefix}-whatsapp-btn`} href={whatsappUrl(text)} target="_blank" rel="noopener noreferrer">
          <MessageCircle className="h-4 w-4" /> Invia su WhatsApp
        </a>
      </Button>
    </div>
  );
};
